import React from 'react'
import { Link } from 'react-router'

export default class RegisterLink extends React.Component {
  render() {
    return (
      <Link to='/register'>
        { this.props.children ? this.props.children : 'Register'}
      </Link>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/RegisterLink.js